export const USD = 'USD'
export const EUR = 'EUR'
export const CHF = 'CHF'
export const AUD = 'AUD'
export const NZD = 'NZD'

const currencies = {
	[USD]: {
		name: 'USD',
		prefix: '$ ',
		suffix: null,
		decimalSeparator: '.',
		groupSeparator: ','
	},
	[EUR]: {
		name: 'EUR',
		prefix: null,
		suffix: ' €',
		decimalSeparator: ',',
		groupSeparator: '.'
	},
	[CHF]: {
		name: 'CHF',
		prefix: null,
		suffix: ' CHF',
		decimalSeparator: ',',
		groupSeparator: '.',
		long: true
	},
	[AUD]: {
		name: 'AUD',
		prefix: null,
		suffix: ' AUD',
		decimalSeparator: ',',
		groupSeparator: '.',
		long: true
	},
	[NZD]: {
		name: 'NZD',
		prefix: null,
		suffix: ' NZD',
		decimalSeparator: ',',
		groupSeparator: '.',
		long: true
	}
}

export default currencies
